// eslint-disable-next-line ts/ban-ts-comment
// @ts-nocheck
import Vue3EasyDataTable from 'vue3-easy-data-table'
import App from '~/App.vue'

import { auth0 } from '~/plugins/auth0'

import pinia from '~/plugins/pinia'
import { configureSentry, initSentry } from '~/plugins/sentry'
import vuetify from '~/plugins/vuetify'
import { loadFonts } from '~/plugins/webfontloader'
import { router } from '~/router'
import { useAppVersionStore } from '~/stores/appVersion'
import { vPhoneInput } from './plugins/phoneInput'

import 'v-phone-input/styles'
import 'vue3-easy-data-table/dist/style.css'
import '@olive/component-library/style.css'
import '~/styles/global.scss'
import '~/styles/animation.scss'

await loadFonts()

const app = createApp(App)

app
  .use(vuetify)
  .use(pinia)
  .use(router)
  .use(auth0)
  .use(vPhoneInput)
  .component('EasyDataTable', Vue3EasyDataTable)

initSentry(app)
app.mount('#app')

router.isReady().then(() => {
  const redirectPath = sessionStorage.getItem('post_update_redirect')

  if (redirectPath) {
    sessionStorage.removeItem('post_update_redirect')
    router.replace(redirectPath)
  }
})
// Initialize app version tracking and background SW update checks
useAppVersionStore()

// Force reload for dynamic chunk loading failures
window.addEventListener('vite:preloadError', () => {
  const reloadKey = `chunk_reload_${window.location.pathname}`
  if (!sessionStorage.getItem(reloadKey)) {
    sessionStorage.setItem(reloadKey, 'true')
    sessionStorage.setItem('post_update_redirect', router.currentRoute.value.fullPath)
    window.location.reload()
  }
})

// --- Lazy-load Sentry after mount ---
if ('requestIdleCallback' in window) {
  requestIdleCallback(async () => {
    configureSentry(app, router)
  })
}
else {
  setTimeout(async () => {
    configureSentry(app, router)
  }, 300)
}

// Lazy-load GA after idle time
if ('requestIdleCallback' in window) {
  requestIdleCallback(async () => {
    const { default: ga } = await import('~/plugins/googleAnalytics')
    app.use(ga)
  })
}
else {
  setTimeout(async () => {
    const { default: ga } = await import('~/plugins/googleAnalytics')
    app.use(ga)
  }, 300)
}
